import { createRoutine } from 'redux-saga-routines'
import { ITodoState, iTodo } from './todo.interface'

import { SHOW_ALL } from './constants'
import {translate} from '../i18n'

const initialTodoState: ITodoState = {
  todos: [{
    id: 1,
    completed: false,
    text: `${translate('todos.useRedux')}`
  }],
  loading: false,
  error: false,
  visibility: SHOW_ALL
}

export const addTodo = createRoutine('ADD_TODO')
export const deleteTodo = createRoutine('DELETE_TODO')
export const editTodo = createRoutine('EDIT_TODO')
export const completeTodo = createRoutine('COMPLETE_TODO')
export const completeAllTodos = createRoutine('COMPLETE_ALL_TODOS')
export const clearCompleted = createRoutine('CLEAR_COMPLETED')
export const setVisibilityFilter = createRoutine('SET_VISIBILITY_FILTER')

export default function todos (state = initialTodoState, action: any) {
  switch (action.type) {
    case addTodo.TRIGGER:
      return {
        ...state,
        todos: [...state.todos,
          {
            id: state.todos.reduce((maxId: number, todo: iTodo) => Math.max(todo.id, maxId), -1) + 1,
            completed: false,
            text: action.payload
          }
        ]
      }

    case deleteTodo.TRIGGER:
      return {...state,
        todos: state.todos.filter((todo: iTodo) =>
          todo.id !== action.payload
        )
      }

    case editTodo.TRIGGER:
      return {...state,
        todos: state.todos.map((todo: iTodo) =>
          todo.id === action.payload.id
            ? { ...todo, text: action.payload.text }
            : todo
          )
      }

    case completeTodo.TRIGGER:
      return {...state,
        todos: state.todos.map((todo: iTodo) =>
          todo.id === action.payload
            ? { ...todo, completed: !todo.completed }
            : todo
          )
      }

    case completeAllTodos.TRIGGER:
      const areAllMarked = state.todos.every((todo: iTodo) => todo.completed)
      return {...state,
        todos: state.todos.map((todo: iTodo) => ({
          ...todo, completed: !areAllMarked
        }))
      }

    case clearCompleted.TRIGGER:
      return {...state, todos: state.todos.filter((todo: iTodo) => todo.completed === false)}

    case setVisibilityFilter.TRIGGER:
      return {...state, visibility: action.payload}

    default:
      return state
  }
}
